import { useTranslation } from "next-i18next";

import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export const Contact = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignSelf: "flex-start",
        gap: "10px",
      }}
    >
      <Typography component={"h2"} variant="subtitle">
        {t("footer.contact")}
      </Typography>
      <Typography variant="code1">Blues Brackets sp. z o. o.</Typography>
      <Typography variant="code1">NIP 8842824071</Typography>
      <Typography variant="code1">REGON 527681035</Typography>
    </Box>
  );
};
